import { Button, DefaultCard, DefaultContent, EleicoesList } from '../components';
import { FaPlus, FaPlusCircle } from 'react-icons/fa';
import { FunctionComponent, useEffect, useState } from 'react';
import { LayoutEnum, SituacaoEleicaoEnum } from '../enums';
import { useAuthAxios, useErrorHandler, useLayout } from '../hooks';

import { ApiHelper } from '../helpers';
import { EleicaoResponseType } from '../types';
import { Spinner } from '../utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EleicoesView: FunctionComponent = () => {
  const { t } = useTranslation();
  const axios = useAuthAxios();
  const errorHandler = useErrorHandler();
  const navigate = useNavigate();
  const [eleicoes, setEleicoes] = useState<EleicaoResponseType[]>([]);
  const [loadingEleicoes, setLoadingEleicoes] = useState(true);
  const { setLayout } = useLayout();

  useEffect(() => {
    setLayout(LayoutEnum.BASE_LAYOUT);
    axios
      .get(ApiHelper.getUrl.apiSCE.eleicoes())
      .then((response) => {
        setEleicoes(response.data);
      })
      .catch((error) => {
        errorHandler(error, t('erro.recuperar_eleicoes'));
      })
      .finally(() => setLoadingEleicoes(false));
  }, []);

  return loadingEleicoes ? (
    <Spinner />
  ) : (
    <DefaultContent>
      <DefaultCard
        cardTitle={t('label.eleicoes_presididas')}
        cardSubtitle={t('texto.lista_eleicoes_presididas')}
        empty={eleicoes?.length <= 0}
        emptyMessage={t('texto.nenhuma_eleicao_cadastrada')}
        emptyIcon={FaPlusCircle}
        mainActionName={t('label.cadastrar')}
        mainAction={() => navigate('/eleicoes/cadastrar')}
        mainActionIcon={FaPlus}
        singleCardPage
      >
        {eleicoes?.length > 0 ? (
          <div className="d-flex flex-column gap-2">
            <EleicoesList
              eleicoes={eleicoes!.filter((eleicao) => eleicao.situacao === SituacaoEleicaoEnum.NAO_PUBLICADA.key)}
              setEleicoes={setEleicoes}
              statusLabel={t(`${SituacaoEleicaoEnum.NAO_PUBLICADA.descricao}s`)}
              colorClass={SituacaoEleicaoEnum.NAO_PUBLICADA.color_class}
            />
            <EleicoesList
              eleicoes={eleicoes!.filter((eleicao) => eleicao.situacao === SituacaoEleicaoEnum.PUBLICADA.key)}
              setEleicoes={setEleicoes}
              statusLabel={t(`${SituacaoEleicaoEnum.PUBLICADA.descricao}s`)}
              colorClass={SituacaoEleicaoEnum.PUBLICADA.color_class}
            />
            <EleicoesList
              eleicoes={eleicoes!.filter((eleicao) => eleicao.situacao === SituacaoEleicaoEnum.CANCELADA.key)}
              setEleicoes={setEleicoes}
              statusLabel={t(`${SituacaoEleicaoEnum.CANCELADA.descricao}s`)}
              colorClass={SituacaoEleicaoEnum.CANCELADA.color_class}
            />
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <p>{t('texto.nenhuma_eleicao_cadastrada')}</p>
            <Button title={t('label.cadastrar')} onClick={() => navigate('/eleicoes/cadastrar')} />
          </div>
        )}
      </DefaultCard>
    </DefaultContent>
  );
};

export default EleicoesView;
